export default __webpack_public_path__ + "static/media/Path 477@2x.181ab32a.png";